var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25895 16.5934C3.14076 14.7084 2.74916 12.48 3.15768 10.3267C3.56621 8.17341 4.74675 6.24331 6.47764 4.89884C8.20853 3.55437 10.3707 2.88801 12.5581 3.0249C14.7455 3.16178 16.8078 4.09249 18.3575 5.64225C19.9073 7.19202 20.838 9.25423 20.9749 11.4417C21.1118 13.6291 20.4455 15.7912 19.101 17.5221C17.7565 19.253 15.8264 20.4336 13.6732 20.8421C11.5199 21.2507 9.29149 20.8591 7.40649 19.7409L7.40651 19.7408L4.29808 20.6289C4.16947 20.6657 4.03338 20.6673 3.90391 20.6338C3.77443 20.6002 3.65628 20.5327 3.5617 20.4381C3.46713 20.3435 3.39956 20.2254 3.36601 20.0959C3.33246 19.9664 3.33415 19.8303 3.37089 19.7017L4.25901 16.5933L4.25895 16.5934Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5H15",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5H15",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientChat);
export default __webpack_public_path__ + "static/media/ClientChat.b0ce5bf0a365585365d6319c5fb86d92.svg";
export { ForwardRef as ReactComponent };